import { ROUTES, cn } from '@/shared/lib';
import {
  AvatarWithIndicator,
  AvatarWithIndicatorProps,
  Link,
} from '@/shared/ui';

import { createAvatarFallback } from '../lib/helpers';

interface IUserAvatarProps extends AvatarWithIndicatorProps {
  isLink?: boolean;
}

export const UserAvatar = ({
  className,
  avatar,
  isLink = true,
  indicatorClassName,
  defaultAvatar,
  ...props
}: IUserAvatarProps) => {
  const avatarFallback = createAvatarFallback({});

  const hasNotifications = false;

  const Comp = isLink ? Link : 'div';

  return (
    <Comp to={ROUTES.PROFILE} className="relative z-50">
      <AvatarWithIndicator
        defaultAvatar={defaultAvatar ?? avatarFallback}
        avatar={avatar}
        variant="md"
        avatarClassName={className}
        showIndicator={hasNotifications}
        indicatorClassName={cn('border-surface-00', indicatorClassName)}
        indicatorPosition="top"
        {...props}
      />
    </Comp>
  );
};
